/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthFacade } from '~app/app/~store/facades/auth.facade';
import { UserRole } from '~core/models/auth.models';

@Component({
  selector: 'user-information',
  templateUrl: './user-information.component.html',
  styleUrl: './user-information.component.scss'
})
export class UserInformationComponent {
  authFacade = inject(AuthFacade);

  currentUser$ = this.authFacade.currentUser$;

  userRoles$ = this.currentUser$.pipe(
    map(user => (user?.roles ?? []) as UserRole[])
  );
}
